// Binary (0/1 bit string) <-> Base64 conversion (operates on raw bytes, not text).

function binaryToBytes(binary: string): Uint8Array {
  const clean = binary.replace(/\s/g, '');
  if (clean.length === 0) return new Uint8Array(0);
  if (clean.length % 8 !== 0) throw new Error('Binary string must be a multiple of 8 digits (one full byte)');
  if (/[^01]/.test(clean)) throw new Error('Invalid binary characters — only 0 and 1 are allowed');
  const bytes = new Uint8Array(clean.length / 8);
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = parseInt(clean.substr(i * 8, 8), 2);
  }
  return bytes;
}

function bytesToBase64(bytes: Uint8Array): string {
  let bin = '';
  bytes.forEach((b) => { bin += String.fromCharCode(b); });
  return btoa(bin);
}

function base64ToBytes(b64: string): Uint8Array {
  const bin = atob(b64.trim());
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes;
}

function bytesToBinary(bytes: Uint8Array): string {
  return Array.from(bytes).map((b) => b.toString(2).padStart(8, '0')).join(' ');
}

export function binaryToBase64(binary: string): string {
  return bytesToBase64(binaryToBytes(binary));
}

export function base64ToBinary(b64: string): string {
  return bytesToBinary(base64ToBytes(b64));
}
